import React, { useEffect, useState } from 'react';
const SizeOptions = ({ currentVariant, allVariants, selectSize }) => {
    const [sizeItems, setSizeItems] = useState([]);
    useEffect(() => {
        const currentYarn = currentVariant.options.length > 1 ? currentVariant.options[1] : null;
        const currentSizeOptions = currentYarn ? allVariants.filter((variant) => variant.options.includes(currentYarn)) : allVariants;
        setSizeItems(currentSizeOptions);
    }, [currentVariant]);
    if (sizeItems.length < 2)
        return null;
    return (React.createElement(React.Fragment, null, sizeItems.map((sizeItem, index) => (React.createElement("button", { className: `size-option ${currentVariant.title === sizeItem.title ? 'size-option--active' : ''}`, key: sizeItem.title, onClick: () => selectSize(sizeItem) }, sizeItem.options[0])))));
};
export default SizeOptions;
